import React, { Component, Fragment } from 'react';
import { FieldGroup, FieldControl, FormBuilder } from 'react-reactive-form';
import { Auth, API } from 'aws-amplify';
import { readableResponseMessage } from 'ux-helpers';
import PropTypes from 'proptypes';
import moment from 'moment';
import {
  formatDate,
  formatTripName,
  formatPackageTitle,
  getActualStartDate,
  getActualEndDate,
} from './../../../helpers/TripHelper';
import clock from './../../../assets/clock.png';
import pending from './../../../assets/small-pending-icon.png';
import './TripTopBar.scss';
import { withRouter } from 'react-router-dom';

class TripTopBar extends Component {
  state = {
    trip: this.props.trip,
    tripIndex: this.props.user.trips.map(trip => trip.id).indexOf(this.props.tripId),
    requestExtension: false,
    id: this.props.trip.id,
  };

  componentDidMount() {
    Auth.currentSession().then(user => {
      this.setState({
        headers: {
          Authorization: user.idToken.jwtToken,
          Token: user.accessToken.jwtToken,
        },
      });
    });

    const paymentExtensionControl = this.tripTopBarForm.get('paymentExtension');
    const documentExtensionControl = this.tripTopBarForm.get('documentExtension');

    paymentExtensionControl.onValueChanges.subscribe(value => {
      if (value === true) {
        this.tripTopBarForm.controls.extensionType.setValue('Payments');
      }
      if (paymentExtensionControl.value || documentExtensionControl.value) {
        this.setState({ requestExtension: true });
      } else {
        this.setState({ requestExtension: false });
      }
    });

    documentExtensionControl.onValueChanges.subscribe(value => {
      if (value === true) {
        this.tripTopBarForm.controls.extensionType.setValue('Documents');
      }
      if (paymentExtensionControl.value || documentExtensionControl.value) {
        this.setState({ requestExtension: true });
      } else {
        this.setState({ requestExtension: false });
      }
    });
  }

  tripTopBarForm = FormBuilder.group({
    extensionNotes: [this.state.trip.extensionNotes],
    extensionType: '',
    paymentExtension: '',
    documentExtension: '',
  });

  handleSubmit = e => {
    e.preventDefault();
    if (this.tripTopBarForm.status === 'VALID') {
      this.setState({ loadingBtn: true });
      this.tripTopBarForm.handleSubmit();
      const { headers } = this.state;
      headers['Content-Type'] = 'application/json';
      //TODO: remove date from body post when API deployed
      // If the data extensionType value exist and it does not equal to "Both",
      // set the value of the input control value to "Both".
      if (
        (this.state.trip.extensionType &&
          this.state.trip.extensionType.length &&
          this.state.trip.extensionType !== 'Both') ||
        (this.tripTopBarForm.controls.paymentExtension.value &&
          this.tripTopBarForm.controls.documentExtension.value)
      ) {
        this.tripTopBarForm.controls.extensionType.setValue('Both');
      }
      const options = {
        headers,
        body: {
          extensionNotes: this.tripTopBarForm.controls.extensionNotes.value,
          extensionType: this.tripTopBarForm.controls.extensionType.value,
        },
      };

      API.post('give-api', `/documents/${this.state.id}/extension`, options)
        .then(response => {
          this.setState({
            trip: {
              ...this.state.trip,
              extensionType: response.Data.extensionType,
              extensionNotes: response.Data.extensionNotes,
            },
            loadingBtn: false,
            requestExtension: false,
            message: response.Message,
          });
          setTimeout(() => {
            this.setState({ message: '' });
          }, 3000);
          this.tripTopBarForm.handleSubmit();
          this.props.setTripState(this.props.tripIndex, this.state.trip);
        })
        .catch(error => {
          this.setState({
            loadingBtn: false,
            message: readableResponseMessage(error),
          });
          this.tripTopBarForm.handleSubmit();
        });
    } else {
      this.setState({ loadingBtn: false });
      this.tripTopBarForm.handleSubmit();
    }
  };

  formatPackageName = (destination, addOns) => {
    var packageName = formatPackageTitle(destination, addOns);
    return packageName;
  };

  scrollToId = oId => {
    const container = document.getElementById('#' + oId);
    container.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  render() {
    const {
      destination,
      startDate,
      endDate,
      documentsDue,
      paymentDue,
      documentExtension,
      paymentExtension,
      extensionType,
      currentAddOns,
      availableAddOns,
    } = this.props.trip;

    const {
      payments: { tripAmount, tripBalance, deposit },
    } = this.props.trip;

    const todaysDate = moment();
    const documentDueWarning = moment(documentsDue, 'MMMM Do, YYYY').diff(moment(), 'days');
    const paymentDueWarning = moment(paymentDue, 'MMMM Do, YYYY').diff(moment(), 'days');
    const paymentExtensionWarning = moment(paymentExtension, 'MMMM Do, YYYY').diff(
      moment(),
      'days'
    );
    const documentExtensionWarning = moment(documentExtension, 'MMMM Do, YYYY').diff(
      moment(),
      'days'
    );

    const countDownResult = moment(
      startDate,
      ['YYYY-MM-DD', 'MMMM D, YYYY', 'MMMM Do, YYYY'],
      true
    ).diff(todaysDate);

    const countDownInDays = moment().diff(
      moment(startDate, ['YYYY-MM-DD', 'MMMM D, YYYY', 'MMMM Do, YYYY'], true),
      'days'
    );

    const countDown =
      countDownInDays >= 0
        ? '0 Days'
        : countDownInDays === -1
        ? '1 Day'
        : countDownInDays < -1 && countDownInDays > -90
        ? `${Math.abs(countDownInDays)} Days`
        : moment.duration(countDownResult).humanize();

    // Calculate the actual trip start and end dates based on add-ons

    const actualStartDate = getActualStartDate(startDate, currentAddOns);
    const actualEndDate = getActualEndDate(endDate, currentAddOns);

    let depositBalance = tripAmount - tripBalance - deposit;
    let addOnsSecured = [];
    for (var i = 0; i < currentAddOns.length; i++) {
      if (depositBalance >= currentAddOns[i].deposit) {
        addOnsSecured.push(true);
        depositBalance = depositBalance - currentAddOns[i].deposit;
      } else {
        addOnsSecured.push(false);
      }
    }

    return (
      <div id="trip-top-bar" className="trip-top-bar">
        <div className="header-border margin-bottom-container top-padding col-md-12">
          <h2
            className="h1-style no-margin-text"
            dangerouslySetInnerHTML={{
              __html: `${this.formatPackageName(destination, currentAddOns)}`,
            }}
          />
        </div>

        <div className="header-border margin-bottom-container col-md-3">
          <h3 className="h1-style muted no-margin-text">Trip Dates:</h3>
          <h4>{formatDate(actualStartDate, actualEndDate)}</h4>
          <p className="no-margin-text inline muted">t-minus</p>
          <img id="clock" src={clock} alt="clock" />
          <p className="no-margin-text">
            <strong>{countDown}</strong> until your trip!
          </p>
        </div>
        <div className="col-md-9 responsive-col">
          <div className="col-md-6 col-sm-12 margin-bottom-container padding-right">
            {currentAddOns && currentAddOns.length ? (
              <h3 className="h1-style muted no-margin-text">Your Add-Ons:</h3>
            ) : availableAddOns && availableAddOns.length ? (
              <h3 className="h1-style muted no-margin-text">Add-Ons:</h3>
            ) : (
              ''
            )}
            {currentAddOns && currentAddOns.length ? (
              <Fragment>
                <div className="top-padding">
                  <p className="no-margin-text muted">Registered Add-Ons:</p>
                  {currentAddOns.map((addOn, addOnIndex) => (
                    <div key={addOn.id}>
                      <h4 className="no-margin-text">
                        {/* <strong className="success strong">+</strong>{" "} */}
                        {addOn.name.includes('UNIV')
                          ? 'UNIV 304'
                          : formatTripName(
                              addOn.name,
                              addOn.addOnStartDate,
                              addOn.addOnEndDate
                            )}{' '}
                        {!addOnsSecured[addOnIndex] ? (
                          <button
                            onClick={e =>
                              this.props.deleteTripAddOn(
                                this.state.id,
                                this.state.tripIndex,
                                addOnIndex,
                                addOn
                              )
                            }
                            className="btn-plain-text"
                            disabled={this.props.isProcessing}
                          >
                            <span className="small muted">remove</span>
                          </button>
                        ) : (
                          ''
                        )}
                      </h4>
                    </div>
                  ))}
                </div>
              </Fragment>
            ) : (
              ''
            )}
            {availableAddOns && availableAddOns.length ? (
              <Fragment>
                <div className="top-padding">
                  <p className="no-margin-text muted">Extend Your Trip:</p>
                  {availableAddOns.map((addOn, addOnIndex) => (
                    <div key={addOn.id}>
                      <h4 className="no-margin-text">
                        {addOn.name.includes('UNIV')
                          ? 'UNIV 304'
                          : formatTripName(
                              addOn.name,
                              addOn.addOnStartDate,
                              addOn.addOnEndDate
                            )}{' '}
                        <button
                          onClick={e =>
                            this.props.addTripAddOn(addOn, addOnIndex, this.state.tripIndex)
                          }
                          className="btn-plain-text"
                          disabled={this.props.isProcessing}
                        >
                          <span className="small muted">add</span>
                        </button>
                      </h4>
                    </div>
                  ))}
                </div>
                {/* <div className="top-padding">
                  <a href="#add-ons">See Available Add-Ons!</a>
                </div> */}
              </Fragment>
            ) : (
              ''
            )}
          </div>
          <div className="col-md-6 col-sm-12 responsive-col padding-right">
            <h3 className="h1-style muted no-margin-text">Deadlines:</h3>
            <div className="col-md-6 col-sm-12 responsive-col top-padding padding-right">
              {extensionType ? (
                <div>
                  <p>
                    <strong>
                      Your request for{' '}
                      {extensionType !== 'Both' ? extensionType : 'Payment and Documents'} extension{' '}
                      {extensionType !== 'Both' ? 'is' : 'are'} pending.
                    </strong>
                    <img id="pending" src={pending} alt="pending" />
                  </p>
                </div>
              ) : (
                ''
              )}
              {tripBalance > 0 ? (
                <Fragment>
                  <p className="muted no-margin-text">
                    {paymentExtension ? 'Extended ' : ''}
                    Payment Deadline:{' '}
                  </p>
                  <p
                    className={`no-margin-text ${paymentExtension ? 'brand-primary' : ''} ${
                      paymentExtensionWarning <= 30 || paymentDueWarning <= 30 ? 'warning' : ''
                    }`}
                  >
                    <strong>
                      {paymentExtension
                        ? moment(paymentExtension).format('MMMM Do, YYYY')
                        : moment(paymentDue, 'MMMM Do, YYYY').format('MMMM Do, YYYY')}
                    </strong>
                  </p>
                </Fragment>
              ) : (
                <p className="brand-primary no-margin-text strong">Payments Completed &#10004;</p>
              )}
              {this.props.allDocumentsUploaded !== this.props.tripId ? (
                <Fragment>
                  <p className="muted no-margin-text">
                    {documentExtension ? 'Extended ' : ''}
                    Documents Deadline:{' '}
                  </p>
                  <p
                    className={`no-margin-text ${documentExtension ? 'brand-primary' : ''} ${
                      documentExtensionWarning <= 30 || documentDueWarning <= 30 ? 'warning' : ''
                    }`}
                  >
                    <strong>
                      {documentExtension
                        ? moment(documentExtension).format('MMMM Do, YYYY')
                        : moment(documentsDue, 'MMMM Do, YYYY').format('MMMM Do, YYYY')}
                    </strong>
                  </p>
                </Fragment>
              ) : (
                <p className="brand-primary no-margin-text strong">Documents Completed &#10004;</p>
              )}
            </div>
            <div className="col-md-6 col-sm-12 top-padding responsive-col padding-right">
              <div className={documentExtension && paymentExtension ? 'hidden' : ''}>
                {/* TODO: change when api done */}
                {this.state.message ? (
                  <p
                    id="error"
                    className={`${
                      this.state.message === 'Successfully Added Extensions' ? 'success' : 'error'
                    }`}
                  >
                    {this.state.message !== 'Successfully Added Extensions'
                      ? this.state.message
                      : ''}
                  </p>
                ) : (
                  ''
                )}
                {Math.abs(countDownInDays) > 30 ? (
                  <FieldGroup
                    control={this.tripTopBarForm}
                    render={({ value, submitted }) => (
                      <form
                        name="Trip Top-Bar"
                        id="trip-top-bar-form"
                        onSubmit={e => this.handleSubmit(e, value)}
                        autoComplete="off"
                        style={{ margin: '0px' }}
                      >
                        <div
                          className={`${
                            (extensionType && extensionType === 'Payments') ||
                            extensionType === 'Both' ||
                            tripBalance < 1
                              ? 'hidden'
                              : ''
                          }`}
                        >
                          <FieldControl
                            name="paymentExtension"
                            render={({ handler }) => (
                              <div className="checkboxContainer">
                                <label className="inline muted small-text strong">
                                  Payment extension
                                </label>
                                <input type="checkbox" {...handler('checkbox')} />
                              </div>
                            )}
                          />
                        </div>
                        <p />
                        <div
                          className={`${
                            (extensionType && extensionType === 'Documents') ||
                            extensionType === 'Both' ||
                            this.props.allDocumentsUploaded === this.props.tripId
                              ? 'hidden'
                              : ''
                          }`}
                        >
                          <FieldControl
                            name="documentExtension"
                            render={({ handler }) => (
                              <div className="checkboxContainer">
                                <label className="inline muted small-text strong">
                                  Document extension
                                </label>
                                <input type="checkbox" {...handler('checkbox')} />
                              </div>
                            )}
                          />
                        </div>
                        {this.state.requestExtension ? (
                          <div>
                            <FieldControl
                              name="extensionNotes"
                              render={({ handler, touched, hasError, pristine }) => (
                                <div className="inputContainer">
                                  <textarea className="form-control" type="text" {...handler()} />
                                  <label
                                    htmlFor="extensionNotes"
                                    className={`label ${
                                      pristine && !this.tripTopBarForm.controls.extensionNotes.value
                                        ? ''
                                        : 'notEmpty'
                                    }`}
                                  >
                                    Extension Details
                                    <span className="error">
                                      {(touched || submitted) &&
                                        hasError('required') &&
                                        ' - Required'}
                                    </span>
                                  </label>
                                </div>
                              )}
                            />
                            <button
                              className={`bottom-margin ${
                                this.state.loadingBtn ? 'btn-text-hide' : ''
                              }`}
                              type="submit"
                              disabled={this.state.loadingBtn}
                            >
                              Submit
                              <span className={`${this.state.loadingBtn ? 'loader' : ''}`} />
                            </button>
                          </div>
                        ) : (
                          ''
                        )}
                      </form>
                    )}
                  />
                ) : (
                  ''
                )}
              </div>
              {(paymentExtensionWarning <= 30 ||
                (paymentDueWarning <= 30 && this.props.trip.payments.tripBalance > 0) ||
                documentExtensionWarning <= 30 ||
                documentDueWarning <= 30) &&
              this.props.allDocumentsUploaded !== this.props.tripId ? (
                <div id="warning-icon-container">
                  <span className="icon-container warning-icon" />
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TripTopBar.propTypes = {
  allDocumentsUploaded: PropTypes.bool,
  setTripState: PropTypes.func.isRequired,
  trip: PropTypes.shape({
    payments: PropTypes.shape({
      tripBalance: PropTypes.number,
      tripAmount: PropTypes.number,
      deposit: PropTypes.number,
      addOnsDeposit: PropTypes.number,
    }),
    documentExtension: PropTypes.string,
    paymentExtension: PropTypes.string,
    destination: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    documentsDue: PropTypes.string,
    paymentDue: PropTypes.string,
    tripFBGroup: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  deleteTripAddOn: PropTypes.func.isRequired,
  addTripAddOn: PropTypes.func.isRequired,
  tripIndex: PropTypes.number.isRequired,
  tripId: PropTypes.string.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  currentAddOns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      addOnStartDate: PropTypes.string,
      addOnEndDate: PropTypes.string,
      tripAddOnId: PropTypes.string,
      tripId: PropTypes.string,
      unitPrice: PropTypes.number,
    })
  ).isRequired,
};

TripTopBar.defaultProps = {
  allDocumentsUploaded: true,
};

export default withRouter(TripTopBar);
